import "./Protocols.module.css";
import Header from "@/reusable_sections/Header";
import IntroductionToMOProtocolSystem from "./sections/IntroductionToMOProtocolSystem";
import MMetabolicGutOptimization from "./sections/MMetabolicGutOptimization";
import OHormoneOptimization from "./sections/OHormoneOptimization";
import PPerformanceLongevity from "./sections/PPerformanceLongevity";
import LLaboratorySupplement from "./sections/LLaboratorySupplement";
import Footer from "@/reusable_sections/Footer";
export default function ProtocolsPage() {
  return <div>
      <Header />
      <IntroductionToMOProtocolSystem />
      <MMetabolicGutOptimization />
      <OHormoneOptimization />
      <PPerformanceLongevity />
      <LLaboratorySupplement />
      <Footer />
    </div>;
}